import { render } from "./AccountAboutToExpire.vue?vue&type=template&id=e72fdd04&scoped=true"
import script from "./AccountAboutToExpire.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AccountAboutToExpire.vue?vue&type=script&charset=utf-8&lang=js"

import "./AccountAboutToExpire.vue?vue&type=style&index=0&id=e72fdd04&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72fdd04"]])

export default __exports__